import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"min-height":"300px"} }
const _hoisted_2 = { style: {"text-align":"right","margin-bottom":"20px"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("关闭")

import { ref, reactive, onMounted, unref } from 'vue';

import { GbDialog } from '@/components/GbDialog/Index';
import { GbTables } from '@/components/GbTables';
import PostRelWriter from './DeptPostRelWriter.vue'

import { useGbTable } from '../../../../hooks/useGbTable';

import { GetCatDeptRelListApi, DelDeptRelApi } from '@/apis/ct_categorys_config/categorycfg.api';

import { TableColumn } from '../../../../components/GbTables/GbTablesTypes';
import { CatDeptRelSearchDto, CatDeptRelDelDto } from '@/apis/ct_categorys_config/categorycfg.dto';


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const writerRef = ref<ComponentRef<typeof PostRelWriter>>()

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<any>({
    getListApi: GetCatDeptRelListApi,
    delListApi: DelDeptRelApi,
    response: {
        data: 'data',
        total: 'total'
    }
})

const { setSearchParams } = methods

const search = reactive<CatDeptRelSearchDto>({
    current: 1,
    page_size: 99,
    id: '',
})

const tabColumns = reactive<TableColumn[]>([
    { field: 'dept_name', label: '部门名称', columnWidth: "120" },
    { field: 'posts_list', label: '关联职位' },
    { field: 'action', width: '120', label: "操作", fixed: 'right', align: 'center' },
])

const state = reactive({
    showDialog: false,
    loading: false,
})

/* 按钮操作 */
const actions = {
    showWriter: () => {
        unref(writerRef)?.showDialog(search.id)
    },

    editor: (row: any) => {
        unref(writerRef)?.editor(row)
    },

    /* 删除关联记录 */
    deleteRel: async (row: any) => {
        const delInput: CatDeptRelDelDto = { id: row.id, revision: row.revision }
        await methods.deleteRows(delInput)

        setSearchParams(search)
    }
}

/* 打开对话框 */
const showDialog = async (configId: string) => {
    search.id = configId
    setSearchParams(search)

    state.showDialog = true
}

expose({ showDialog })


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ElButton = _resolveComponent("ElButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(GbDialog), {
      modelValue: _unref(state).showDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).showDialog) = $event)),
      title: "部门/岗位设置",
      style: {"width":"720px"}
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          size: "small",
          type: "info",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).showDialog = false))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              width: "85",
              onClick: actions.showWriter
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_unref(GbTables), {
            "show-paged": false,
            selection: false,
            columns: _unref(tabColumns),
            data: _unref(tableObject).tableList,
            loading: _unref(tableObject).loading,
            onRegister: _unref(register)
          }, {
            action: _withCtx(({ row }) => [
              _createVNode(_component_ElButton, {
                size: "small",
                type: "success",
                link: "",
                onClick: ($event: any) => (actions.editor(row))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_ElButton, {
                size: "small",
                type: "danger",
                link: "",
                onClick: ($event: any) => (actions.deleteRel(row))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["columns", "data", "loading", "onRegister"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(PostRelWriter, {
      ref_key: "writerRef",
      ref: writerRef,
      onSave: _cache[2] || (_cache[2] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
    }, null, 512)
  ], 64))
}
}

})